var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('md-app',[_c('md-app-toolbar',{staticClass:"md-primary"},[_c('span',{staticClass:"md-title"},[_vm._v("User-Agent.Dev")])]),_c('md-app-content',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }